import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes.constants";

const LoginPage = lazy(() => import("@/src/auth/pages/login.page"));
const InviteAcceptPage = lazy(() => import("@/src/auth/pages/invite-accept.page"));
const OAuthConsentPage = lazy(() => import("@/src/auth/pages/oauth-consent.page"));

/**
 * Public auth routes (mounted under `PublicLayout`).
 */
export const authPublicRoutes: RouteObject[] = [
	{ path: AUTH_ROUTES.login, element: <LoginPage /> },
	{ path: "/otp", element: <Navigate to={AUTH_ROUTES.login} replace /> },
	{ path: AUTH_ROUTES.inviteAcceptPattern, element: <InviteAcceptPage /> },
];

/**
 * Standalone auth routes (no layout — rendered on a plain background).
 */
export const authStandaloneRoutes: RouteObject[] = [{ path: AUTH_ROUTES.oauthConsent, element: <OAuthConsentPage /> }];

export const authProtectedRoutes: RouteObject[] = [];
